import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'showSources';

@Injectable({
  providedIn: 'root',
})
export class ShowSourceService {
  private readonly showSourcesSubject: BehaviorSubject<boolean>;
  showSources$: Observable<boolean>;

  constructor() {
    const storedValue = localStorage.getItem(STORAGE_KEY);
    const initialValue = storedValue === null ? true : storedValue === 'true';
    this.showSourcesSubject = new BehaviorSubject<boolean>(initialValue);
    this.showSources$ = this.showSourcesSubject.asObservable();
  }

  setShowSources(value: boolean = true) {
    this.showSourcesSubject.next(value);
    localStorage.setItem(STORAGE_KEY, value.toString());
  }

  getCurrentValue(): boolean {
    return this.showSourcesSubject.getValue();
  }
}
